import { createSlice } from '@reduxjs/toolkit';

const packSlice = createSlice({
	name: 'packs',
	initialState: [],
	reducers: {
		setPacks: (state, action) => {
			return action.payload;
		},
		addPack: (state, action) => {
			state.push(action.payload);
		},
		updatePack: (state, action) => {
			const index = state.findIndex((pack) => pack.id === action.payload.id);
			if (index !== -1) {
				state[index] = action.payload;
			}
		},
		removePack: (state, action) => {
			return state.filter((pack) => pack.id !== action.payload);
		},
		updatePackPricing: (state, action) => {
			const { packId, precio_calculado, precio_final, ahorro } = action.payload;
			const pack = state.find((pack) => pack.id === packId);
			if (pack) {
				pack.precio_calculado = precio_calculado;
				pack.precio_final_personalizado = precio_final;
				pack.precio_mostrar = precio_final;
				pack.ahorro = ahorro;
				pack.precio = precio_final;
			}
		},
	},
});

export const { setPacks, addPack, updatePack, removePack, updatePackPricing } = packSlice.actions;

export default packSlice.reducer;
